import React, { useState, useEffect, useRef } from 'react';
import style from './RecordSetting.module.css';
import { useNavigate } from 'react-router-dom';
import URL from '../../../../constants/url';
import axiosApi from '../../../../api/daonAxios';

import HeadSub from '../../../../components/comm/HeadSub';
import CODE from '../../../../constants/code';
import { formatDate } from '../../../../assets/js/comm';

import noDataImg from '../../../../images/common/i_3d_no_data_doc.svg';
import Skeleton from '@mui/material/Skeleton';

const RecordSetting = () => {


    /*****************
     * 주요 변수 선언부
     ******************/

    const navigate = useNavigate();
    const user = JSON.parse(sessionStorage.getItem("loginUser"));

    // 기록목록
    const [recordList, setRecordList] = useState([]);

    // 화면초기화 useRef 선언
    const isInitialRender = useRef(true);

    // 로딩 상태
    const [loading, setLoading] = useState(true);


    /*****************
     * 기능 함수 선언부
     ******************/

    const searchRecordTargetList = () => {

        const requestRecordListUrl = "/homecare/tkmdcn/retrieveTakingMedicineInfoList";

        const jToken = localStorage.getItem('jToken');

        const requestOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            }
        }

        const requestData = { usrHsptlMap: user.usrHsptlMap };

        setLoading(true);

        axiosApi.post(requestRecordListUrl, requestData, requestOptions)
            .then( (res) => {
                const resData = res.data;
                if( resData.resultCode === CODE.RCV_SUCCESS ) {
                    //recordTargetListTag(resData.result?.tkmdcnInfoList);
                    //setRecordList(resData.result?.tkmdcnInfoList);
                    setRecordList( recordTargetListTag(resData.result?.tkmdcnInfoList) );
                } else {
                    setRecordList([]);
                }
            })
            .catch( err => {
                console.log(" ==================> searchRecordTargetList error : ", err );
            })
            .finally(() => {
                setLoading(false);
            })
    };

    const recordTargetListTag = (recordList) => {

        const recordTag = [];

        let selectIdx = 1;
        recordList.forEach( (item) => {

            const paramData = JSON.parse(item.cnncPrmtrVal);

            recordTag.push(
                <li key={selectIdx}>
                    <div className={style['left-box']}>
                        <strong>{item.hsptlNm}</strong>
                        <p>{item.deptNm}</p>
                        <span>{formatDate(item.prscrptnDt)}</span>
                    </div>
                    <div className={style['right-box']}>
                        <div className={style['record-count']}>
                            <span>복약 기록 <b>{item.tkmdcnCnt}</b></span>
                            {/* <span>건강 기록 <b>2</b> </span> */}
                        </div>
                        <button 
                            className='btn' 
                            data-btn-type="fill-main" 
                            data-btn-size='sm' 
                            onClick={()=> navigate(URL.RECORD_SETTING_DETAIL, { 
                                state: { 
                                    paramData,
                                    item: {
                                    alrmExprDt: item.alrmExprDt,
                                    hsptlCd: item.hsptlCd,
                                    hsptlNm: item.hsptlNm,
                                    patntId: item.patntId,
                                    deptCd: item.deptCd,
                                    deptNm: item.deptNm,
                                    prscrptnDt: item.prscrptnDt
                                    }
                            }
                        })}>
                            <span>설정하기</span>
                        </button>
                    </div>
                </li>
            )
            selectIdx++;
        });

        return recordTag;
    }

    // 스켈레톤 UI 렌더링
    const renderSkeleton = () => {
        return [1, 2, 3].map((index) => (
            <li key={`skeleton-${index}`}>
                <div className={style['left-box']}>
                    <strong><Skeleton variant="text" width={100} height={22} /></strong>
                    <p><Skeleton variant="text" width={100} height={20} /></p>
                    <span><Skeleton variant="text" width={80} height={20} /></span>
                </div>
                <div className={style['right-box']}>
                    <div className={style['record-count']}>
                        <Skeleton variant="rectangular" width={70} height={24} style={{ borderRadius: 4 }} />
                    </div>
                    <Skeleton variant="rectangular" width={70} height={24} style={{ borderRadius: 4 }} />
                </div>
            </li>
        ));
    };


    useEffect( () => {

        if( isInitialRender.current ) {
            searchRecordTargetList();
            isInitialRender.current = false;
        }
    }, [] );

    return (
        <>
            <HeadSub title="기록 설정" />

            <div id="sub-content" >
                 <div className='inner-wrap' data-pad="normal">


                        <div className={style['record-lists-box']}>
                            <ul>

                                {loading && renderSkeleton()}
                                
                                {!loading && recordList.length > 0 && recordList}

                                {!loading && recordList.length <= 0 &&
                                    <li className={style['no-data-box']}>
                                        <div className={style['img-box']}>
                                            <object data={noDataImg} aria-hidden='true'></object>
                                        </div>
                                        <p>기록 설정이 없습니다.</p>
                                    </li>
                                }
                                {/* hard cord
                                <li>
                                    <div className={style['left-box']}>
                                        <strong>여의도 성모</strong>
                                        <p>혈액내과</p>
                                        <span>25.02.10</span>
                                    </div>
                                    <div className={style['right-box']}>
                                        <div className={style['record-count']}>
                                            <span>복약 기록 <b>3</b></span>
                                            <span>건강 기록 <b>2</b> </span>
                                        </div>
                                        <button className='btn' data-btn-type="fill-main" data-btn-size='sm' onClick={()=> navigate(URL.RECORD_SETTING_DETAIL)}>
                                            <span>설정하기</span>
                                        </button>
                                    </div>
                                </li>

                                <li>
                                    <div className={style['left-box']}>
                                        <strong>서울 성모</strong>
                                        <p>간담췌외과</p>
                                        <span>25.02.10</span>
                                    </div>
                                    <div className={style['right-box']}>
                                        <div className={style['record-count']}>
                                            <span>복약 기록 <b>3</b></span>
                                            <span>건강 기록 <b>2</b> </span>
                                        </div>
                                        <button className='btn' data-btn-type="fill-main" data-btn-size='sm'>
                                            <span>설정하기</span>
                                        </button>
                                    </div>
                                </li>
                                */}
                            </ul>
                        </div>

                </div>
            </div>

        </>
    );
};

export default RecordSetting;
